<template>
  <m-categories-wrapper>
    <b-row slot-scope="{categories,flatCategories}">

      <swiper id="categories306-categories-slider" class="w-100 px-5" ref="mySwiper" :options="swiperOptions">

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>

        <swiper-slide>
          <m-single-contents-wrapper contentLink="category-image">
            <template slot-scope="{content}">

              <div class="category-item p-3" :class="{'category-active':selectedCategory === null}"
                   @click="selectCategory('')">
                <b-row class="p-0 m-o">
                  <b-col>
                    <img :src="content.thumbnail"
                         :alt="findAttributeOnSiteInfo('site_name')[0]" class="col-lg-12">
                  </b-col>
                  <b-col class="category-name-parent">
                    <div class="">
                      <span>آخرین ها</span>
                    </div>
                  </b-col>
                </b-row>
              </div>

            </template>
          </m-single-contents-wrapper>
        </swiper-slide>
        <swiper-slide v-for="category in flatCategories(categories)" :key="category.id"
                      v-if="category.products_count > 0" class=" ">


          <div class="category-item p-3"
               :class="{'category-active':JSON.stringify(selectedCategory) === JSON.stringify([category.slug])}"
               @click="selectCategory(category)">
            <b-row class="p-0 m-o">
              <b-col>
                <img :src="category.image"
                     :alt="category.name" class="col-lg-12">
              </b-col>
              <b-col>
                <div class="category-name-parent">
                  <span>{{ category.name }}</span>
                </div>
              </b-col>
            </b-row>
          </div>

        </swiper-slide>


      </swiper>
    </b-row>
  </m-categories-wrapper>
</template>

<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Categories306",
  components: {Swiper, SwiperSlide, directive,},
  data() {
    return {
      selectedCategory: null,
      swiperOptions: {
        spaceBetween: 10,
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 5,

          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = []
      if (category !== '') {
        this.selectedCategory.push(category.slug)
        this.$emit('category', this.selectedCategory)
        return true
      }
      this.selectedCategory = null
      this.$emit('category', this.selectedCategory)
    },
  }
}
</script>

<style>
#categories306-categories-slider .swiper-button-next, #categories306-categories-slider .swiper-button-prev {
  color: var(--light-cyan) !important;
}
</style>

<style scoped>
.category-item {
  background: var(--secondary) !important;
  color: white !important;
  cursor: pointer;
}

.category-active {
  background: gray !important;
}

.category-name-parent {
  display: table;
  font-size: 12px;
}

.category-name-parent > div {
  display: table-cell;
  vertical-align: middle;
}
</style>